import { namespace } from 'vuex-class';
import { IContentLinkBlockState } from '@/content-link/store/content-link.types';

export const ContentLink = namespace('contentLink');

export enum EContentLinkAction {
  Preview = 'preview',
  PreviewSuccess = 'previewSuccess',
  PreviewFailed = 'previewFailed',
  SetPreview = 'setPreview',
  SetExistingData = 'setExistingData',
  SetURLValidation = 'setURLValidation',
  Update = 'update',
  PreviewScrapeFailed = 'previewScrapeFailed',
  ResetState = 'resetState',
  SaveEdit = 'saveEdit',
  Create = 'create',
  CreateSuccess = 'createSuccess',
  CreateFailed = 'createFailed',
}

export enum EContentLinkMutation {
  SetPreview = 'setPreview',
  SetExistingData = 'setExistingData',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetSaving = 'setSaving',
  ClearData = 'clearData',
  SetURLValidation = 'setURLValidation',
  SetMessage = 'setMessage',
  SetIsCreated = 'setIsCreated',
}

export const state: IContentLinkBlockState = {
  loading: false,
  loaded: false,
  saving: false,
  validUrl: undefined,
  message: undefined,
  preview: {
    id: '',
    title: '',
    description: '',
    url: '',
    buttonText: '',
    thumbUrl: '',
    thumbExtension: '',
    user: null,
  },
  created: false,
};
